import { infiniteQueryOptions } from '@tanstack/vue-query'
import { getAlerts } from '../api/get-alerts'

export const ALERTS_QUERY_KEY = ['alerts'] as const

export const alertsQueryOptions = infiniteQueryOptions({
  queryKey: ALERTS_QUERY_KEY,
  queryFn: ({ pageParam }) => getAlerts({ after: pageParam }),
  getNextPageParam: lastPage => (lastPage.hasNextPage ? lastPage.endCursor.toString() : undefined),
  initialPageParam: undefined as string | undefined,
  staleTime: 60_000,
})
